import React, { RefObject } from "react";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { DestinationsStore } from "./DestinationsStore";
import { useTranslation } from "react-i18next";
import type { FormikProps } from "formik";
import { observer } from "mobx-react-lite";

export const DestinationsModalButtons: React.FC<{
  formikContext: RefObject<FormikProps<any> | null>;
  formikErrorHasErrors: boolean;
  store: DestinationsStore;
}> = observer(({ formikContext, formikErrorHasErrors, store }) => {
  const { t } = useTranslation();

  return (
    <ModalButtons
      buttonType={"button"}
      testId={`modal-save-button`}
      submitText={store.testConnectionPromise?.state === "pending" ? t("destinations_page.test_connection") : t("destinations_page.save")}
      isSubmitDisabled={formikErrorHasErrors || store.testConnectionPromise?.state === "pending"}
      onSubmit={() => formikContext.current?.submitForm()}
      hideCancel={true}
    />
  );
});
